import { MagnifyingGlass } from '@phosphor-icons/react';

export default MagnifyingGlass;
